import React, { useState, useEffect, useContext } from "react";
// import { useHistory } from 'react-router';

// COMPONENTS
import Aside from "./components/aside/aside";
import Header from "./components/header/header";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";

//styles
import Footer from "./components/footer/footer";
import "./styles/styles.scss";

const Layout = ({ children }) => {
  return (
    <main className="m-0 p-0 tiny-scrollbar  d-flex flex-column justify-content-start align-items-stretch">
      <Header />
      <section className="main_content flex-grow-1  m-0 p-0 d-flex flex-row justify-content-start align-items-stretch">
        {children}
      </section>
      <Footer />
    </main>
  );
};

export default Layout;
